import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-aktion2';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAktion2Effects {

    VeranstaltungAktion2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_AKTION2),
        mergeMap((x: ac.GetVeranstaltungAktion2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungAktion2(x.veranstaltung_id, x.aktionId).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungAktion2ErfolgreichAction(result, x.veranstaltung_id, x.aktionId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungAktion2FehlerAction(error, x.veranstaltung_id, x.aktionId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AktionenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AktionenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AktionenQueryService);
        }
        return this.service;
    }
}
